import React from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import BodyContentLayout from './layout/BodyContentLayout';
import LeftContentLayout from './layout/LeftContentLayout';
import RightContentLayout from './layout/RightContentLayout';
import Resource from './Resource';

const DEFAULT_TITLE = 'More Resources';

const MoreResources = ({
  title,
  label,
  items,
  useClassroomResourceAddress,
  showIcon,
  unitNumber,
  subunitTitle,
  iconName,
}) => {
  const isReviewUnit = unitNumber === '0';
  const hasResourceIcon = iconName === 'Resources';
  const isTeacherResource =
    isReviewUnit && hasResourceIcon && subunitTitle === 'Teacher Resources';
  const isStudentResource =
    isReviewUnit && hasResourceIcon && subunitTitle === 'Student Resources';
  let icon;
  if (isTeacherResource) {
    icon = 'teacher_resources';
  } else if (isStudentResource) {
    icon = 'student_resources';
  } else {
    icon = 'more_resources';
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <BodyContentLayout>
      <RightContentLayout
        title={title || DEFAULT_TITLE}
        showIcon={showIcon}
        label={label}
        icon={icon}
      />

      <LeftContentLayout>
        {items.map((item) => (
          <Resource
            item={item}
            useClassroomResourceAddress={useClassroomResourceAddress}
            unitNumber={unitNumber}
          />
        ))}
      </LeftContentLayout>
    </BodyContentLayout>
  );
};

MoreResources.propTypes = {
  title: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  items: PropTypes.array.isRequired,
  useClassroomResourceAddress: PropTypes.bool.isRequired,
  showIcon: PropTypes.bool,
  unitNumber: PropTypes.string.isRequired,
  subunitTitle: PropTypes.string,
  iconName: PropTypes.string,
};

MoreResources.defaultProps = {
  title: DEFAULT_TITLE,
  label: '',
  iconName: '',
  subunitTitle: '',
  showIcon: true,
};

export default withApollo(MoreResources);
